import { useState, useEffect } from 'react';
import { supabase, BACKEND_URL } from '../supabaseClient';

export const useProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchProfile = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session) {
          const response = await fetch(`${BACKEND_URL}/api/profile`, {
            headers: {
              'Authorization': `Bearer ${session.access_token}`
            }
          });
          
          if (!response.ok) throw new Error('Failed to fetch profile');
          
          const data = await response.json();
          if (isMounted) setProfile(data);
        }
      } catch (err) {
        console.error("Profile Hook Error:", err);
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchProfile();

    return () => { isMounted = false; };
  }, []);

  return { profile, loading, error };
};